export default __webpack_public_path__ + "static/media/imgIpadModal.08ece748.png";